var defaultStyles = {
  "root": "Base-VendorButton",
  "icon": "Base-VendorButton--Icon",
  "googlePay": "Base-VendorButton--GooglePay",
  "applePay": "Base-VendorButton--ApplePay",
  "amazonPay": "Base-VendorButton--AmazonPay",
  "googleSocial": "Base-VendorButton--GoogleSocial",
  "facebookSocial": "Base-VendorButton--FacebookSocial",
  "disabled": "Base-VendorButton--Disabled",
  "fluid": "Base-VendorButton--Fluid"
};

export { defaultStyles as default };
